export const enum ROOT_ROUTES {
  signIn = 'signin-callback',
  notFound = 'not-found',
  conversationData = 'conversation-data',
  agentPerformance = 'agent-performance',
}

export const enum QUERY_PARAMS {
  callDetailId = 'call-detail-id',
  aceCommunicationId = 'ace-communication-id',
  aceSessionId = 'ace-session-id',
  routingId = 'routing-id',
  errorId = 'error-id',
  view = 'view',
  markComplete = 'markComplete',
  hiddenQuestions = 'hiddenQuestions',
}

export type TDataQueryName =
  | QUERY_PARAMS.routingId
  | QUERY_PARAMS.callDetailId
  | QUERY_PARAMS.aceCommunicationId
  | QUERY_PARAMS.aceSessionId;

export const CONVERSATION_QUERY_PARAM_NAMES: TDataQueryName[] = [
  QUERY_PARAMS.aceCommunicationId,
  QUERY_PARAMS.aceSessionId,
  QUERY_PARAMS.callDetailId,
  QUERY_PARAMS.routingId,
];
